
const historico = {
    namespaced: true,
    state: () => ({
        table_name: null,
        table_id: null,
        cliente_id: null,
        tem_pendencia: false,
    }),
    mutations: {
        setTableName(state, name) {
            state.table_name = name;
        },
        setClienteId(state, id) {
            state.cliente_id = id;
        },
        setTableId(state, id) {
            state.table_id = id;
        },
        setPendencia(state, pendecia) {       
            state.tem_pendencia = Boolean(parseInt(pendecia));
        }
    },

}


export default historico;